import { css } from '@emotion/react'

// Prevent content from jumping when a modal window is opened.
export const modalLock = css`
  display: none;
`
